/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_YesInputs */

const fr_admin_subscription_rights_yes = /** @type {(inputs: Admin_Subscription_Rights_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

/**

* @param {Admin_Subscription_Rights_YesInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_yes = /** @type {((inputs?: Admin_Subscription_Rights_YesInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_YesInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_yes(inputs)
});